import Sprite from "app/components/sprite";
import classNames from "classnames";
import { Fragment } from "react";
import formatDate from "app/utils/date";
import { createMarkup } from "app/utils/html";

const BlogListItem = ({ post }) => {
  const showTags = false;

  return (
    <Fragment>
      <div
        className={classNames(
          "order-1 flex flex-col justify-center xl:col-start-1 xl:col-end-8",
          { "lg:flex-1 xl:w-full": post.image }
        )}
      >
        <p
          className={classNames(
            "text-lg font-extrabold leading-6 md:text-[28px] md:leading-8 ltr:xl:pr-10 rtl:xl:pl-10",
            post.author ? "mb-4" : "mb-4 lg:mb-0"
          )}
        >
          {post.title}
        </p>
        {post.author ? (
          <div className="mb-5 flex items-center xl:mb-0">
            <div className="h-7 w-7 rounded-full bg-ghostwhite p-1">
              <Sprite name="blog-author" className="h-full w-full" />
            </div>
            <p className="text-[10px] font-medium leading-6 ltr:ml-2 rtl:mr-2">
              Written by {post.author} | {formatDate(post.date)}
            </p>
          </div>
        ) : null}
      </div>
      <div className="order-3 flex flex-col justify-between xl:order-2 xl:col-start-1 xl:col-end-8">
        <div
          className={classNames(
            "mt-1 text-ellipsis text-sm font-medium leading-6 ltr:xl:pr-10 rtl:xl:pl-10",
            { "line-clamp-6": !post.cta }
          )}
          dangerouslySetInnerHTML={createMarkup(post.description)}
        />
        {post.cta && (
          <a
            id={post.cta.id}
            href={post.cta.link}
            rel="noreferrer"
            target="_blank"
            className={classNames(
              "mt-5 flex flex-1 items-center justify-center rounded-full bg-black px-7 py-3 text-sm font-bold lg:max-h-[50px] lg:max-w-fit lg:py-4 lg:text-base lg:font-extrabold xl:mt-0",
              post.cta.textColor ?? "text-white"
            )}
          >
            <p>{post.cta.label}</p>
          </a>
        )}
      </div>
      {showTags && post.tag.length ? (
        <div className="order-3 flex flex-col justify-end xl:order-3 xl:col-start-1 xl:col-end-8">
          <div className="mt-5 flex flex-wrap gap-2 xl:mt-0">
            {post.tag.map((tag, index) => (
              <span
                key={index}
                className="break-all rounded-full bg-ghostwhite px-3 text-[10px] font-extrabold uppercase tracking-wider text-secondary"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      ) : null}
      {post.image && (
        <div className="order-2 mb-7 mt-0 flex items-center lg:mb-0 lg:mt-5 lg:w-2/5 xl:order-4 xl:col-start-8 xl:col-end-13 xl:row-span-2 xl:mt-0 xl:w-full">
          <img
            src={post.image}
            alt={post.title}
            className="h-full w-full rounded-2xl object-cover lg:mb-5 lg:h-[194px] lg:w-[290px] ltr:lg:ml-auto rtl:lg:mr-auto xl:mb-0 xl:h-[300px] xl:w-[460px]"
          />
        </div>
      )}
    </Fragment>
  );
};

export default BlogListItem;
